import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { Box, utilityClasses } from '@fiverr-private/theme';
import { INPUT_ID, INPUT_SIZES } from './constants';
import { InputProps } from './types';
import {
  inputSearchSelector,
  hideNumberSpinButtonClass,
  successClass,
  errorClass,
  input,
  resetInputStyleClass,
  inputSizeLg,
  inputSizeDefault,
} from './styles.ve.css';

const Input = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type = 'text',
      disabled = false,
      isSuccess = false,
      isError = false,
      hideNumberSpinButton = false,
      width = '100%',
      inputSize = INPUT_SIZES.default,
      resetInputStyle = false,
      dataTrackTag = 'input',
      dataTrackValue = '<value>',
      ...rest
    },
    ref
  ) => {
    const inputClassName = classnames(
      {
        [hideNumberSpinButtonClass]: type === 'number' && hideNumberSpinButton,
        [successClass]: isSuccess,
        [errorClass]: isError,
        [resetInputStyleClass]: resetInputStyle,
        [inputSizeLg]: inputSize === INPUT_SIZES.lg,
        [inputSizeDefault]: inputSize === INPUT_SIZES.default,
      },
      input,
      inputSearchSelector,
      utilityClasses.placeholder,
      className
    );

    const inputProps = {
      disabled,
      type,
      ref,
      dataTrackTag,
      dataTrackValue,
      ...rest,
    };

    return (
      <Box
        as="input"
        display="inlineBlock"
        position="relative"
        width={width}
        boxSizing="borderBox"
        className={inputClassName}
        {...inputProps}
      />
    );
  }
);

Input.displayName = INPUT_ID;

Object.assign(Input, {
  id: INPUT_ID,
});

export default Input;
